import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import _sortBy from 'lodash/sortBy';
import { Col, Row } from 'reactstrap';

import { useFormState, useActions } from 'utils/hooks';
import { getAsyncOptions } from 'utils/helpers';

import Input from 'common/components/form/inputs/Input';
import AsyncSelector from 'common/components/selectors/AsyncSelector';

import * as listActions from 'store/lists/actions';

const CrewIdentifier = ({ formState }) => {
  const { fields, changeField, selectField } = useFormState(formState);
  const identifierTypes = _sortBy(useSelector(state => state.lists['identifier-types'])?.options, [
    'type'
  ]);
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);

  useEffect(() => {
    if (!identifierTypes?.length) fetchListOptions('identifier-types');
  }, []);

  return (
    <div>
      <Row className="no-gutters">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>

      <Row className="no-gutter">
        <Col>
          <AsyncSelector
            label="Types"
            onChange={e => selectField('type')(e)}
            getOptionValue={option => option.type}
            getOptionLabel={option => option.type}
            loadOptions={search => getAsyncOptions(search, 'identifier-types')}
            defaultOptions={identifierTypes}
            placeholder=""
            styled={false}
            isClearable
            {...fields.type}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CrewIdentifier;
